"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Backbone = void 0;

var Handlebars = void 0;
var Metrics = void 0;

Backbone = require("backbone");

Handlebars = require("handlebars");

Metrics = require("../helpers/metrics").default;

var ResultsView = void 0;
var append_container = void 0;
var icon = void 0;
var iconlist = void 0;
var pageCount = void 0;
var pageLimit = void 0;
var parent = void 0;
var template = void 0;
var url = void 0;

append_container = void 0;

parent = void 0;

iconlist = void 0;

icon = void 0;

pageCount = void 0;

pageLimit = void 0;

ResultsView = void 0;

url = void 0;

template = (0, _jquery2.default)("#handlebar-template");

var Backbone_Icon_List = function () {
    function Backbone_Icon_List(append_container, ajaxURL, page, handlebar_template, limit, wp_el) {
        _classCallCheck(this, Backbone_Icon_List);

        var Icon = void 0;
        var IconList = void 0;
        var me = void 0;

        this.raw_html = "false";

        this.$wp_el = void 0;

        this.on_finish = void 0;

        this.status = void 0;

        me = this;
        me.$wp_el = wp_el;
        append_container = (0, _jquery2.default)(append_container);
        parent = append_container.parent();
        url = ajaxURL;
        pageCount = page;
        if (limit !== void 0) {
            pageLimit = limit;
        } else {
            pageLimit = 50;
        }
        if (handlebar_template !== void 0) {
            template = handlebar_template;
        }
        Icon = Backbone.Model.extend({
            defaults: {
                loading: '<div class="loading clearfix"><div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div><div class="dot dot4"></div></div>',
                error: "/static/img/fallback-icon.svg",
                id: 0,
                term_slug: "None",
                preview_url: "None"
            },
            idAttribute: "cid"
        });
        IconList = Backbone.Collection.extend({
            model: Icon,
            url: function url() {
                return ajaxURL;
            }
        });
        iconlist = new IconList();
        icon = new Icon();
        ResultsView = Backbone.View.extend({
            el: append_container,
            initialize: function initialize() {
                this.render();
            },
            render: function render() {
                var HTML = void 0;
                var compiled_template = void 0;
                var i = void 0;
                var icon_array = void 0;
                var len = void 0;
                var ref = void 0;
                var wrapper = void 0;
                if (template === "html") {
                    HTML = iconlist.models[0].attributes.html;
                } else {
                    compiled_template = Handlebars.compile(template.html());
                    icon_array = [];
                    ref = iconlist.models;
                    for (i = 0, len = ref.length; i < len; i++) {
                        icon = ref[i];
                        icon_array.push(icon.attributes);
                    }
                    wrapper = {
                        objects: icon_array
                    };
                    HTML = compiled_template(wrapper);
                }
                (0, _jquery2.default)(this.el).append(HTML);
                if (me.on_finish !== void 0) {
                    me.on_finish();
                }
            }
        });
        parent.append(icon.attributes.loading);
        this.scroll();
    }

    _createClass(Backbone_Icon_List, [{
        key: "scroll",
        value: function scroll() {
            var $footer = void 0;
            var $wp_el = void 0;
            var has_failed = void 0;
            var me = void 0;
            me = this;
            has_failed = false;
            $footer = (0, _jquery2.default)("#footer");
            if (this.$wp_el === void 0) {
                $wp_el = (0, _jquery2.default)("#logout-form");
            } else {
                $wp_el = this.$wp_el;
            }
            if (template === "html") {
                icon = Backbone.Model.extend({
                    defaults: {
                        html: "",
                        is_owner: ""
                    }
                });
                iconlist.model = icon;
                me.raw_html = "true";
            }
            return $wp_el.waypoint({
                handler: function handler() {
                    if (has_failed === false) {
                        (0, _jquery2.default)(".loading").removeClass("hidden");
                        if (me.status !== "firing") {
                            me.status = "firing";
                            return iconlist.fetch({
                                data: {
                                    page: pageCount,
                                    limit: pageLimit,
                                    raw_html: me.raw_html
                                },
                                success: function success(method, model, options) {
                                    var resultsView = void 0;
                                    if (model.length === 0) {
                                        has_failed = true;
                                    }
                                    me.status = "finished";
                                    pageCount = pageCount + 1;
                                    if (document.location.pathname === "/search/") {
                                        new noun.Metrics().page_depth(pageCount);
                                    }
                                    resultsView = new ResultsView();
                                    (0, _jquery2.default)(".loading").addClass("hidden");
                                    return Waypoint.refreshAll();
                                },
                                error: function error(jqXHR, textStatus, errorThrown) {
                                    (0, _jquery2.default)(".loading").addClass("hidden");
                                    return has_failed = true;
                                }
                            });
                        }
                    }
                },
                offset: "110%"
            });
        }
    }]);

    return Backbone_Icon_List;
}();

exports.default = Backbone_Icon_List;